import _ from 'lodash'

const getFixedImg = function getFixedImg(image) {
  return _.get(image, ['localFile', 'childImageSharp', 'fixed'], null)
}

export default getFixedImg
